angular.module('MW.InsDashboard.GoogleAnalyticsService', [
    'MW.DashboardLegacy.Constants',
    'MW.Framework.CoreCompanyService'
])
.factory('GoogleAnalyticsService', [
    '$http',
    '$cookies',
    'CoreCompanyService',
    'GOOGLE_ACCOUNT_API',
    'GOOGLE_ANALYTICS_WIDGET_URL',
    function ($http,
        $cookies,
        CoreCompanyService,
        GOOGLE_ACCOUNT_API,
        GOOGLE_ANALYTICS_WIDGET_URL) {
        'use strict';

        var googleAnalyticsService = {};

        function getAuthorizationToken() {
            var gydaToken = $cookies.get('gydaToken');
            return gydaToken.token;
        }

        function transformSessionResponse(response) {
            var matchedUrlList = [],
                matchedSessionCount = [],
                otherSessionCount = [],
                otherReferredSessionCount = [];

            if (response.data && response.data.sessionSummary) {
                angular.forEach(response.data.sessionSummary, function (sessionSummary) {
                    if (sessionSummary.hasOwnProperty('matchedUrlList')) {
                        matchedUrlList.push(sessionSummary.matchedUrlList);
                    }
                    if (sessionSummary.hasOwnProperty('matchedSessionCount')) {
                        matchedSessionCount.push(sessionSummary.matchedSessionCount);
                    }
                    if (sessionSummary.hasOwnProperty('otherSessionCount')) {
                        otherSessionCount.push(sessionSummary.otherSessionCount);
                    }
                    if (sessionSummary.hasOwnProperty('otherReferredSessionCount')) {
                        otherReferredSessionCount.push(sessionSummary.otherReferredSessionCount);
                    }
                });
            }

            return { matchedSessionCount: matchedSessionCount, otherSessionCount: otherSessionCount, otherReferredSessionCount: otherReferredSessionCount, matchedUrlList: matchedUrlList };
        }

        function transformSessionErrorResponse(error) {
            return { matchedSessionCount: [], otherSessionCount: [], fakeData: true , error: error};
        }

        /**
         * Responsible for getting the otherSessionCount and matchedSessionCount per day.
         * 
         * @param {String} viewId the view we are getting sessions for
         * @param {String} timezone the timezone of the view we are getting sessions for
         * @param {String} startDate the start date we are using for the session queries
         * @param {String} endDate the end date we are using for the session queries
         * @param {String} agent the search agent we are using to find matched sessions to documents in our system
         * @param {String} granularity the date granularity we are using for the queries (DAY, WEEK, MONTH, etc...)
         * @param {Boolean} allSessions should we fetch all sessions? if not, we only fetch matched sessions
         * @param {String} refreshCache string representation of Date.now()
         * @returns {Array} of Objects that include otherSessionCount and matchedSessionCount information.  Each Object in the Array represents a day.
         */
        googleAnalyticsService.getSessions = function getSessions(viewId, timezone, startDate, endDate, agent, granularity, allSessions, tag, refreshCache) {
            var formattedStartDate = moment(startDate).clone().toISOString();
            var formattedEndDate = moment(endDate).clone().toISOString();
            var GET_GOOGLE_ANALYTICS_URL = GOOGLE_ANALYTICS_WIDGET_URL + '/v1' + '?viewId=' + viewId + '&timezone=' + timezone + '&startDate=' + formattedStartDate + '&endDate=' + formattedEndDate + '&granularity=' + granularity;


            if (agent) {
                GET_GOOGLE_ANALYTICS_URL += '&agent='+agent;
            } else if (tag) {
                GET_GOOGLE_ANALYTICS_URL += '&tag='+tag;
            }
            
            if (refreshCache) {
                GET_GOOGLE_ANALYTICS_URL += '&refreshCache='+refreshCache;
            }

            var metricsQueryParams = '&metrics=referral';
            if (allSessions) {
                metricsQueryParams += ',other';
            }

            GET_GOOGLE_ANALYTICS_URL += metricsQueryParams;

            return CoreCompanyService.getCurrent(true).then(function handleCompanyResponse(company) {
                GET_GOOGLE_ANALYTICS_URL = GET_GOOGLE_ANALYTICS_URL + '&companyId=' + company._id;

                var config = {
                    headers: {
                      'Authorization': getAuthorizationToken()
                    }
                };

                return $http.get(GET_GOOGLE_ANALYTICS_URL, config)
                    .then(transformSessionResponse)
                    .catch(transformSessionErrorResponse);
            });
        }

        /**
         * Responsible for determining if we have a google account for the current company
         * 
         * @return {Promise} The authenticated users profile information.
         */
        googleAnalyticsService.hasGoogleAccount = function hasGoogleAccount() {
            var googleProfileUrl = GOOGLE_ACCOUNT_API + '/v1/profile?companyId=';

            return CoreCompanyService.getCurrent(true).then(function handleCompanyResponse(company) {
                googleProfileUrl += company._id;
                return $http.get(googleProfileUrl);
            });
        };

        googleAnalyticsService.getUrls = function getUrls() {
            var GET_GOOGLE_ANALYTICS_WIDGET_URL = GOOGLE_ANALYTICS_WIDGET_URL + '/v1/urls';

            return CoreCompanyService.getCurrent(true).then(function handleCompanyResponse(company) {
                GET_GOOGLE_ANALYTICS_WIDGET_URL += '?companyId=' + company._id + '&refreshCache='+Date.now();

                return $http.get(GET_GOOGLE_ANALYTICS_WIDGET_URL);
            });
        }

        googleAnalyticsService.getTimezone = function getTimezone(accountId, webPropertyId, webProfileId, refreshCache) {
            var GET_GOOGLE_TIMEZONE_URL = GOOGLE_ANALYTICS_WIDGET_URL + '/v1/timezone';

            return CoreCompanyService.getCurrent(true).then(function handleCompanyResponse(company) {
                GET_GOOGLE_TIMEZONE_URL += '?companyId=' + company._id + '&accountId=' + accountId + '&webPropertyId=' + webPropertyId + '&webProfileId=' + webProfileId;

                if (refreshCache) {
                    GET_GOOGLE_TIMEZONE_URL += '&refreshCache='+refreshCache;
                }

                var config = {
                    headers: {
                      'Authorization': getAuthorizationToken()
                    }
                };

                return $http.get(GET_GOOGLE_TIMEZONE_URL, config);
            });
        }

        googleAnalyticsService.getReferers = function getReferers(viewId, startDate, endDate) {
            var GET_GOOGLE_REFERERS_URL = GOOGLE_ANALYTICS_WIDGET_URL + '/v1/referers';

            return CoreCompanyService.getCurrent(true).then(function handleCompanyResponse(company) {
                GET_GOOGLE_REFERERS_URL += '?companyId=' + company._id + '&viewId=' + viewId + '&startDate=' + startDate + '&endDate=' + endDate + '&refreshCache='+Date.now();

                return $http.get(GET_GOOGLE_REFERERS_URL);
            });
        }

        return googleAnalyticsService;
    }
]);